var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"fleet-button-grid-item",class:{ 'selected-button': _vm.setClassButton },on:{"click":function($event){return _vm.selectGroup(_vm.group.uid)}}},[_vm._v("\n    "+_vm._s(_vm.group.verbose_name)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ccd6773","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Fleets/fleet-button.vue
// module id = c3w5
// module chunks = 1